const apiPath = '/api';

export default function getApiUrl() {
  const { protocol, hostname } = window.location;
  let { port } = window.location;
  let apiUrl;
  if (hostname.includes('localhost')) {
    port = 4000;
    apiUrl = `${protocol}//${hostname}:${port}${apiPath}/v1`;
  } else {
    apiUrl = `${protocol}//${hostname}${apiPath}/v1`;
  }

  return apiUrl;
}
